import React from 'react';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import './Footer.css';

// Create icon components with proper typing
const FaFacebookF = FaIcons.FaFacebookF as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const FaInstagram = FaIcons.FaInstagram as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const FaYoutube = FaIcons.FaYoutube as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const FaEnvelope = FaIcons.FaEnvelope as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const FaPhoneAlt = FaIcons.FaPhoneAlt as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const FaMapMarkerAlt = FaIcons.FaMapMarkerAlt as React.ComponentType<React.SVGProps<SVGSVGElement>>;

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo-section">
            <div className="footer-logo">
              <img src="/images/logo.png" alt="Dream Advance Logo" className="footer-logo-image" />
            </div>
            <p className="footer-description">
              Ignite your child's imagination with cutting-edge technology through IIITD-IC Summer Camp 2026
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-links-column">
              <h3>Quick Links</h3>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/tracks">Tracks</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/register">Register Now</Link></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h3>Our Tracks</h3>
              <ul>
                <li><Link to="/tracks#robotics">Robotics + IoT + AI</Link></li>
                <li><Link to="/tracks#drone">Drone Tech + Aero Modelling</Link></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h3>Contact</h3>
              <ul>
                <li>
                  <FaPhoneAlt className="contact-icon" />
                  <a href="tel:+919220253001">+91 9220253001</a>
                </li>
                <li>
                  <FaEnvelope className="contact-icon" />
                  <a href="mailto:connect@cograd.in">connect@cograd.in</a>
                </li>
                <li className="address-item">
                  <FaMapMarkerAlt className="contact-icon" />
                  <span>
                    Workspace by Innova, B-4,<br />
                    Sector 63 (Near Sector 62 Metro),<br />
                    Noida 201301
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Dream Advance. All rights reserved.</p>
          <div className="social-links">
            <a href="https://www.facebook.com/share/16Uh4bcAfC/" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/dream.cograd?igsh=MWF1b2k4YW9lNzlpdw==" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaInstagram />
            </a>
            <a href="https://youtube.com/@dreamadvance?si=nzr1-4NwkcCCVu_I" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
